import { cn, snakeToTitleCase } from 'lib/helpers/utility';

import Dot from '../Dot/Dot';
import Icon from '../Icon/Icon';

import {
  ICON_PER_COLOR,
  SIZE_CLASSES,
  getColorFromStatus,
  getContainerClasses,
  getTextClasses
} from './lib/getClasses';

/**
 * @param {import('./lib/propTypes').StatusProps} props
 */

const Status = ({
  status,
  className,
  textClassName,
  color,
  indicator = 'dot',
  variant = 'filled',
  size = 'medium',
  customIcon
}) => {
  const resolvedColor = color || getColorFromStatus(status);
  const sizeConfig = SIZE_CLASSES[size] || SIZE_CLASSES.medium;

  const renderLeadingIndicator = () => {
    if (indicator === 'dot') {
      return <Dot size={sizeConfig.dotSize} color={resolvedColor} />;
    }

    if (indicator === 'icon') {
      const icon = customIcon || ICON_PER_COLOR[resolvedColor] || ICON_PER_COLOR.neutral;
      return <Icon icon={icon} size={sizeConfig.iconSize} color={resolvedColor} />;
    }

    return null;
  };

  return (
    <div
      className={cn(getContainerClasses(resolvedColor, size, variant), className)}
      title={snakeToTitleCase(status)}>
      {renderLeadingIndicator()}
      <span className={cn(getTextClasses(resolvedColor, size), textClassName)}>
        {snakeToTitleCase(status)}
      </span>
    </div>
  );
};

export default Status;
